(() => {
  if (!/\/pages\/questionnaire\b/.test(window.location.pathname)) return;

  const styleId = 'tst-consent-placement-style-v2';

  const injectStyles = () => {
    if (document.getElementById(styleId)) return;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      #tst-questionnaire-consent {
        display: none !important;
      }

      body.tst-consent-review-visible #tst-questionnaire-consent {
        display: block !important;
        position: static !important;
        inset: auto !important;
        z-index: auto !important;
        width: 100% !important;
        max-width: 760px !important;
        margin: 22px 0 18px !important;
        padding: 18px 20px !important;
        border: 1px solid rgba(241, 236, 224, 0.22) !important;
        border-radius: 12px !important;
        background: rgba(14, 14, 13, 0.72) !important;
        box-shadow: none !important;
        backdrop-filter: none !important;
        -webkit-backdrop-filter: none !important;
        transform: none !important;
      }

      #tst-questionnaire-consent * {
        max-width: 100% !important;
      }

      #tst-questionnaire-consent h1,
      #tst-questionnaire-consent h2,
      #tst-questionnaire-consent h3,
      #tst-questionnaire-consent legend,
      #tst-questionnaire-consent [class*="title"],
      #tst-questionnaire-consent [class*="label"]:first-child {
        margin-bottom: 10px !important;
        font-size: 11px !important;
        line-height: 1.2 !important;
        letter-spacing: 0.12em !important;
        text-transform: uppercase !important;
        color: var(--c-amber, #e97826) !important;
      }

      #tst-questionnaire-consent label,
      #tst-questionnaire-consent .agreement {
        display: flex !important;
        align-items: flex-start !important;
        gap: 12px !important;
        margin: 9px 0 !important;
        font-size: 13px !important;
        line-height: 1.4 !important;
        color: rgba(241, 236, 224, 0.94) !important;
      }

      #tst-questionnaire-consent input[type="checkbox"] {
        flex: 0 0 auto !important;
        width: 18px !important;
        height: 18px !important;
        margin-top: 1px !important;
        accent-color: var(--c-amber, #e97826) !important;
      }

      #tst-questionnaire-consent a {
        color: var(--c-amber, #e97826) !important;
        text-decoration: underline !important;
        text-underline-offset: 3px !important;
      }

      body.tst-questionnaire-welcome #tst-questionnaire-consent,
      body.tst-questionnaire-plan #tst-questionnaire-consent {
        display: none !important;
      }

      body.tst-questionnaire-welcome .stage-inner {
        align-items: flex-start !important;
        padding-top: clamp(18px, 3vh, 32px) !important;
      }

      body.tst-questionnaire-welcome #card,
      body.tst-questionnaire-welcome .welcome {
        max-height: none !important;
      }

      body.tst-questionnaire-welcome .welcome__intro {
        margin-bottom: 18px !important;
      }

      body.tst-questionnaire-welcome .welcome__cta-row {
        margin-top: 34px !important;
      }

      body.tst-questionnaire-welcome .welcome__divider {
        margin-top: 18px !important;
        margin-bottom: 16px !important;
      }

      body.tst-questionnaire-welcome #welcome-paynow {
        min-height: 82px !important;
        margin-top: 0 !important;
      }

      @media (min-width: 900px) and (max-height: 700px) {
        body.tst-questionnaire-welcome .qhead {
          padding-top: 12px !important;
          padding-bottom: 12px !important;
        }

        body.tst-questionnaire-welcome .stage-inner {
          padding-top: 8px !important;
          padding-bottom: 8px !important;
        }

        body.tst-questionnaire-welcome #card {
          max-width: 720px !important;
        }

        body.tst-questionnaire-welcome .welcome__badge {
          transform: scale(0.86) !important;
          transform-origin: center !important;
          margin-bottom: 12px !important;
        }

        body.tst-questionnaire-welcome .welcome h1 {
          font-size: clamp(58px, 10vh, 78px) !important;
          line-height: 0.9 !important;
          margin-top: 12px !important;
          margin-bottom: 12px !important;
        }

        body.tst-questionnaire-welcome .welcome__intro {
          font-size: 16px !important;
          line-height: 1.35 !important;
          margin-bottom: 10px !important;
        }

        body.tst-questionnaire-welcome .welcome__meta {
          margin-top: 6px !important;
          gap: 18px !important;
        }

        body.tst-questionnaire-welcome .welcome__cta-row {
          margin-top: 22px !important;
        }

        body.tst-questionnaire-welcome #welcome-start {
          min-height: 68px !important;
          height: 68px !important;
          padding: 0 44px !important;
        }

        body.tst-questionnaire-welcome .welcome__divider {
          margin-top: 12px !important;
          margin-bottom: 10px !important;
        }

        body.tst-questionnaire-welcome #welcome-paynow {
          min-height: 72px !important;
          height: 72px !important;
          width: min(360px, 100%) !important;
          padding: 12px 18px !important;
        }

        body.tst-questionnaire-welcome .welcome__paynow-icon {
          width: 38px !important;
          height: 38px !important;
        }
      }

      @media (max-width: 760px) {
        body.tst-questionnaire-welcome .stage-inner {
          padding-top: 14px !important;
        }

        body.tst-questionnaire-welcome .welcome__cta-row {
          margin-top: 26px !important;
        }

        body.tst-questionnaire-welcome .welcome__divider {
          margin-top: 14px !important;
          margin-bottom: 12px !important;
        }

        body.tst-questionnaire-welcome #welcome-paynow {
          min-height: 76px !important;
        }

        body.tst-consent-review-visible #tst-questionnaire-consent {
          padding: 14px !important;
          margin: 16px 0 14px !important;
        }

        #tst-questionnaire-consent label,
        #tst-questionnaire-consent .agreement {
          font-size: 12px !important;
          gap: 10px !important;
          margin: 7px 0 !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const currentSection = () => (document.getElementById('section-label')?.textContent || '').trim().toLowerCase();
  const cardText = () => (document.getElementById('card')?.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const isWelcomeStep = () => {
    const section = currentSection();
    const text = cardText();
    return section === 'welcome' || text.includes("let's build your plan") || text.includes('lets build your plan');
  };

  const isPlanStep = () => {
    const section = currentSection();
    const text = cardText();
    return section === 'plan' || text.includes('pick your plan') || !!document.querySelector('.plan-grid, .plan-card');
  };

  const isReviewStep = () => {
    const section = currentSection();
    const text = cardText();
    return section === 'review' || text.includes('quick review before we go') || !!document.querySelector('.review');
  };

  const placeConsentOnReview = (panel) => {
    const card = document.getElementById('card');
    if (!card) return;

    const reviewActions = card.querySelector('.review__plan-actions');
    const reviewPlan = card.querySelector('.review__plan');
    const review = card.querySelector('.review');
    const anchor = reviewActions || reviewPlan || review;

    if (anchor && anchor.parentNode) {
      anchor.insertAdjacentElement('afterend', panel);
    } else if (panel.parentElement !== card) {
      card.appendChild(panel);
    }
  };

  const moveConsentToAppShell = (panel) => {
    const app = document.getElementById('tst-app');
    if (app && panel.parentElement !== app) app.appendChild(panel);
  };

  const run = () => {
    injectStyles();

    const panel = document.getElementById('tst-questionnaire-consent');
    if (!panel) return;

    const reviewStep = isReviewStep();
    panel.classList.add('tst-consent-review-step');
    document.body.classList.toggle('tst-questionnaire-welcome', isWelcomeStep());
    document.body.classList.toggle('tst-questionnaire-plan', isPlanStep());
    document.body.classList.toggle('tst-consent-review-visible', reviewStep);

    if (reviewStep) placeConsentOnReview(panel);
    else moveConsentToAppShell(panel);
  };

  run();
  window.addEventListener('load', run);
  window.addEventListener('resize', run);
  document.addEventListener('click', () => setTimeout(run, 30), true);
  document.addEventListener('change', () => setTimeout(run, 30), true);
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();
